import { useCreateOrUpdateMultipleprintInExhibition } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FormLayoutElement } from "@/config/forms/general";
import { MultipleprintInExhibition } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const MultipleprintInExhibitionDrawer = ({
  fields,
  data,
  queryId,
  type,
  open,
  onOpenChange,
}: {
  fields: FormLayoutElement[] | undefined;
  data: MultipleprintInExhibition;
  queryId: string;
  type: LinkableType;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const schema = z.object({
    expositionsDansEstampesMultiplesDescriptionNumero: z.string(),
    expositionsDansEstampesMultiplesDescriptionExemplaireExpose: z.string(),
    exhibition: z.object({
      expositionsDescriptionNumeroExpo: z.string(),
      expositionsDescriptionResume: z.string(),
    }),
  });

  const { mutate: createOrUpdateMultipleprintInExhibition } =
    useCreateOrUpdateMultipleprintInExhibition(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      exhibition: data.exhibition,
      expositionsDansEstampesMultiplesDescriptionNumero:
        data.expositionsDansEstampesMultiplesDescriptionNumero,
      expositionsDansEstampesMultiplesDescriptionExemplaireExpose:
        data.expositionsDansEstampesMultiplesDescriptionExemplaireExpose,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateMultipleprintInExhibition({
      id: data.id,
      multipleprintId: data.multipleprint.id,
      exhibitionId: data.exhibition.id,
      ...formData,
    });
  };
  const isFromExhibition = type === "exhibition";
  const previewConfig = isFromExhibition
    ? {
        attachments: data.multipleprint?.attachments ?? [],
        type: "multipleprint" as const,
        alt:
          data.multipleprint?.estampesMultiplesDescriptionNumeroEnregistrement ??
          data.multipleprint?.estampesMultiplesDescriptionTitre,
      }
    : {
        attachments: data.exhibition?.attachments ?? [],
        type: "exhibition" as const,
        alt:
          data.exhibition?.expositionsDescriptionNumeroExpo ??
          data.exhibition?.expositionsDescriptionTitre,
      };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
      previewImage={previewConfig}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
};

export default MultipleprintInExhibitionDrawer;
